/** venture/office.ts — 진행 주체(로움경영지도사무소 / 올댓벤처스)는 한 곳에서 바꾸면 전부 따라간다 (지도사 2026-09-24
 *  "링크 보낼 때 로고 설정도 거기에 따라 가야지 · 어디서 선택해도 반영되게")
 *  · 등록 화면 · 등록정보 · 자료수집 「로고」 토글 — 어디서 고르든 p.office 하나를 바꾸고
 *  · GP·LP 카드의 brand(고객 화면 로고)를 같은 값으로 맞추고
 *  · 이미 만든 자료수집 포털(GP·LP 링크 + 14단계 키트 링크)의 로고도 서버에서 한 번에 바꾼다 (URL 은 그대로) */
import { setPortalBrand } from './api';
import { officeOf, officeInfo, LOCKED_OFFICE } from './types';
import type { Project, Office, PersonCard } from './types';

const KIT_PORTAL_PREFIX = 'cp_';   // kit13.portalKey — s13 txt 'cp_<coId>_<mode>' = 자료수집 프로젝트 id

/** office 변경 패치 — 카드 brand 미러 포함 */
export function officePatch(p: Project, office: Office): Partial<Project> {
  const patch: Partial<Project> = { office };
  if (p.collect) {
    const withBrand = (c: PersonCard): PersonCard => ({ ...c, brand: office });
    patch.collect = { ...p.collect, gp: withBrand(p.collect.gp), lps: (p.collect.lps || []).map(withBrand) };
  }
  return patch;
}

/** 이 프로젝트가 만든 자료수집 포털 id 전부 (GP·LP 카드 + 14단계 키트 링크) */
export function portalIds(p: Project): string[] {
  const ids: string[] = [];
  if (p.collect) [p.collect.gp, ...(p.collect.lps || [])].forEach((c) => { if (c && c.collectProjectId) ids.push(c.collectProjectId); });
  const txt = (p.s13 && p.s13.txt) || {};
  Object.keys(txt).forEach((k) => { if (k.indexOf(KIT_PORTAL_PREFIX) === 0 && txt[k]) ids.push(txt[k]); });
  return Array.from(new Set(ids));
}

/** 바꾼 뒤 기존 포털 로고 반영 — 실패해도 화면은 이미 바뀌어 있으니 토스트로만 알린다 */
export async function pushOfficeBrand(p: Project, office: Office, toast: (m: string) => void): Promise<void> {
  const ids = portalIds(p);
  const name = officeInfo(office).name;
  if (!ids.length) { toast('진행 주체 · ' + name + ' — 앞으로 만드는 자료수집 링크는 이 로고로 나갑니다'); return; }
  try {
    const r = await setPortalBrand(p.id, office, ids);
    toast('진행 주체 · ' + name + ' — 이미 보낸 자료수집 링크 ' + r.updated + '건의 로고도 바꿨습니다 (URL 그대로)');
  } catch (e) { toast('포털 로고 반영 실패: ' + ((e as Error).message || '') + ' — 자료수집 탭에서 로고를 다시 골라 주세요'); }
}

/** 한 곳에서 고르면 전부: 패치 + 기존 포털 반영 */
export function changeOffice(p: Project, office: Office, onPatch: (patch: Partial<Project>) => void, toast: (m: string) => void): void {
  if (officeOf(p) === office && p.office === office) return;
  if (LOCKED_OFFICE && office !== LOCKED_OFFICE) { toast('올댓벤처스 화면에서는 진행 주체를 바꿀 수 없습니다 — 로움파트너스에서 바꿔 주세요'); return; }
  onPatch(officePatch(p, office));
  pushOfficeBrand(p, office, toast);
}
